import Component from '../core/Component'
import { toggleClass } from '../utils/dom'

export const STATES = {
    READY: 'is-ready',
    ACTIVE: 'is-active',
    ANIMATING: 'is-animating',
}

export default class OpeningHours extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: [],
        }

        this.timer = null
        this.current = 0
    }

    prepare() {
        this.ref.items[0].classList.add(STATES.ACTIVE)
        this.element.offsetWidth
        this.element.classList.add(STATES.READY)

        setTimeout(() => {
            this.start()
        })
    }

    start() {
        this.timer = setInterval(this.next, 4000)
        this.element.classList.add(STATES.ANIMATING)
    }

    stop() {
        clearInterval(this.timer)
        this.element.classList.remove(STATES.ANIMATING)
    }

    next = () => {
        const next = (this.current + 1) % this.ref.items.length

        this.ref.items.forEach((item, index) => {
            toggleClass(item, STATES.ACTIVE, index === next)
        })

        this.current = next
    }
}
